/**
 * Module-level, IN-MEMORY holder for the data-room session bearer.
 *
 * SECURITY (non-negotiable — this is a bearer for PII): the session token lives ONLY here, in a JS
 * variable. It is NEVER written to localStorage / sessionStorage / cookies (the legacy enclave's sin
 * was a JWT in localStorage, XSS-exfiltratable). It dies on tab close and on refresh — recovery is a
 * re-exchange of the invite token from the URL (see src/session/SessionProvider.tsx).
 *
 * Kept out of React state so the axios request interceptor (api/client.ts) reads it synchronously and
 * never closes over a stale render.
 */

let sessionToken: string | null = null;
let onExpired: (() => void) | null = null;

export function setSessionToken(token: string | null): void {
  sessionToken = token;
}

export function getSessionToken(): string | null {
  return sessionToken;
}

/** Registered by the SessionProvider; invoked by the API client on a 401 (reject-closed). */
export function setExpiredHandler(fn: (() => void) | null): void {
  onExpired = fn;
}

export function handleSessionExpired(): void {
  onExpired?.();
}
